import { render, staticRenderFns } from "./factorajepp.vue?vue&type=template&id=29c99f78&"
import script from "./factorajepp.vue?vue&type=script&lang=js&"
export * from "./factorajepp.vue?vue&type=script&lang=js&"
import style0 from "./factorajepp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports